import { queryOptions } from "@/lib/query";

import { apiClient } from "./client";
import type { AdminDoctorMutationResponse, PendingDoctorsResponse } from "@/types/admin";

const secretHeaders = (secret: string) => ({ "x-admin-secret": secret });

/** Only the three documented Admin Approval endpoints. Nothing else. */
export const adminApi = {
  pendingDoctors: (secret: string, signal?: AbortSignal) =>
    apiClient.request<PendingDoctorsResponse>("/admin/doctors/pending", {
      headers: secretHeaders(secret),
      signal,
    }),

  approveDoctor: (secret: string, id: string) =>
    apiClient.request<AdminDoctorMutationResponse>(`/admin/doctors/${id}/approve`, {
      method: "POST",
      headers: secretHeaders(secret),
    }),

  rejectDoctor: (secret: string, id: string, reason?: string) =>
    apiClient.request<AdminDoctorMutationResponse>(`/admin/doctors/${id}/reject`, {
      method: "POST",
      headers: secretHeaders(secret),
      ...(reason && reason.trim() ? { body: { reason: reason.trim() } } : {}),
    }),
};

export const adminKeys = {
  pending: ["admin", "doctors", "pending"] as const,
};

export const pendingDoctorsQuery = (secret: string | null) =>
  queryOptions({
    queryKey: adminKeys.pending,
    queryFn: () => adminApi.pendingDoctors(secret ?? ""),
    enabled: Boolean(secret),
    retry: false,
    staleTime: 15_000,
  });
